import { useEffect, useState } from "react";
import ReactLoading from "react-loading";
import Transition from "../../../common/components/transition/transition";
import { useLoadHandler } from "../../../common/customHooks/useLoadHandler";
import { LoadingStatus } from "../../../common/enums/loadingStatus";
import { QuestionTypes } from "../../../common/enums/questionTypes";
import { loadCampaignData } from "../../../common/reducers/campaignDataReducer";
import { CampaignApi } from "../../../common/services/api/campaignApi";
import { Color } from "../../../common/style/colors";
import { RootState, useAppDispatch, useAppSelector } from "../../../store";
import { BlockType } from "../../createCampaign/enums/blockType";
import {
  CampaignBlockModel,
  QuestionModel,
} from "../../createCampaign/models/questionModel";
import CampaignCover from "../components/campaignCover/campaignCover";
import CampaignPolicyPopup from "../components/campaignPolicyPopup/campaignPolicyPopup";
import CampaignQuestions from "../components/campaignQuestions/campaignQuestions";
import "./campaignPage.scss";

export default function CampaignPage() {
  const [index, setIndex] = useState(0);
  const path =
    window.location.href.split("/")[window.location.href.split("/").length - 1];
  const dispatch = useAppDispatch();
  const campaignData = useAppSelector((state: RootState) => state.campaign);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [showPolicyPopup, setShowPolicyPopup] = useState(false);

  const { loadingStatus: loadingStatus, callFetchAsync: callFetchAsync } =
    useLoadHandler(async () => {
      let result = await CampaignApi().campaignDetailByPath(path);
      return () => dispatch(loadCampaignData(result));
    });

  useEffect(() => {
    callFetchAsync();
    window.addEventListener(
      "resize",
      function () {
        setWindowWidth(window.innerWidth);
      },
      true
    );
  }, []);

  return (
    <>
      <div className="campaign-container">
        {loadingStatus == LoadingStatus.LOADING ? (
          <ReactLoading
            type={"spin"}
            color={Color().primaryColor}
            height={50}
            width={50}
          />
        ) : loadingStatus == LoadingStatus.ERROR ? (
          <p>Oops, Somthing Went Wrong !</p>
        ) : (
          <>
            <Transition index={index} isFadeOut={true}>
              <CampaignCover
                buttonPosition={campaignData.coverDetail.buttonPosition}
                buttonColor={campaignData.theme?.themeColor?.value}
                buttonText={campaignData.coverDetail.buttonText}
                fontFamily={campaignData.theme?.fontFamily}
                onSubmit={() => {
                  if (campaignData.coverDetail.policy) {
                    setShowPolicyPopup(true);
                  } else {
                    setIndex(index + 1);
                  }
                }}
                url={
                  windowWidth < 600
                    ? campaignData.coverDetail.mobileBackground
                    : campaignData.coverDetail.desktopBackground
                }
              />
              <CampaignQuestions
                campaignId={campaignData.id}
                theme={campaignData.theme}
                initialData={(campaignData.TicketDetail.fullName?.isShow
                  ? [
                      {
                        blockType: BlockType.QUESTION,
                        questionBlockDetail: {
                          questionType: QuestionTypes.SHORT_ANSWER,
                          questionTitle:
                            campaignData.TicketDetail.fullName?.data,
                        } as QuestionModel,
                      } as CampaignBlockModel,
                    ]
                  : []
                ).concat([...campaignData.campaignBlock])}
                ticketData={campaignData.TicketDetail}
              />
            </Transition>
          </>
        )}
      </div>
      {showPolicyPopup && (
        <CampaignPolicyPopup
          fontStyle={campaignData.theme?.fontFamily}
          onAccept={() => {
            setShowPolicyPopup(false);
            setIndex(index + 1);
          }}
          onDecline={() => setShowPolicyPopup(false)}
          text={campaignData.coverDetail.policy}
        />
      )}
    </>
  );
}
